import React from 'react';
import { Icon } from '../../assets/icons/Icon.jsx';

const SIZES = { large: { box: 40, icon: 24 }, medium: { box: 32, icon: 20 }, small: { box: 24, icon: 16 } };

export function IconButton({
  icon,
  variant = 'normal',
  size = 'medium',
  disabled = false,
  shape = 'rounded',
  style,
  ...rest
}) {
  const s = SIZES[size] || SIZES.medium;
  let look;
  if (disabled) look = { background: variant === 'background' ? 'var(--interaction-disable)' : 'transparent', color: 'var(--label-disable)', boxShadow: variant === 'outlined' ? 'inset 0 0 0 1px var(--line-normal-alternative)' : 'none' };
  else if (variant === 'background') look = { background: 'var(--fill-normal)', color: 'var(--label-normal)', boxShadow: 'none' };
  else if (variant === 'outlined') look = { background: 'var(--background-normal-normal)', color: 'var(--label-normal)', boxShadow: 'inset 0 0 0 1px var(--line-normal-neutral)' };
  else look = { background: 'transparent', color: 'var(--label-normal)', boxShadow: 'none' };

  return (
    <button
      type="button"
      disabled={disabled}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: s.box,
        height: s.box,
        padding: 0,
        border: 'none',
        borderRadius: shape === 'circle' ? 'var(--radius-full)' : 'var(--radius-sm)',
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'background var(--duration-fast) var(--ease-standard)',
        WebkitTapHighlightColor: 'transparent',
        ...look,
        ...style,
      }}
      {...rest}
    >
      <Icon name={icon} size={s.icon} />
    </button>
  );
}

export default IconButton;
